import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
function AccordionItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-[#0d2b24] border border-cream/10 rounded-2xl overflow-hidden" data-id="element-324">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 md:px-8 md:py-6 flex items-center justify-between text-left focus:outline-none" aria-expanded={isOpen} data-id="element-325">
        <span className="font-serif text-lg md:text-xl text-cream pr-4" data-id="element-326">
          {question}
        </span>
        <ChevronDownIcon className={`w-5 h-5 text-peach transition-transform duration-300 shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-327" />
      </button>
      <AnimatePresence data-id="element-328">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-329">
            <p className="px-6 pb-6 md:px-8 md:pb-7 text-sand leading-relaxed" data-id="element-330">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function NewFAQ() {
  const faqs = [{
    q: '¿Reemplaza este plan al tratamiento médico?',
    a: 'No. Este plan es un complemento nutricional diseñado para reducir la inflamación sistémica. Siempre debes consultar con tu médico especialista.'
  }, {
    q: '¿Cuándo veré resultados?',
    a: 'La mayoría de las mujeres reportan una reducción significativa en la hinchazón (endo-belly) durante la primera semana. Los cambios en el dolor menstrual suelen notarse a partir del primer o segundo ciclo completo.'
  }, {
    q: '¿Tengo que seguirlo de forma perfecta?',
    a: 'No. Enseñamos la regla del 80/20. Lo importante es la constancia, no la perfección. Te enseñaremos cómo manejar los desvíos sin perder el progreso.'
  }, {
    q: '¿Qué pasa con los síntomas iniciales?',
    a: 'Durante los primeros 3-4 días de la fase detox puedes sentir leve fatiga o dolor de cabeza mientras tu cuerpo elimina toxinas. Es normal y temporal.'
  }, {
    q: '¿Funciona si no tengo endometriosis diagnosticada?',
    a: 'Sí. El protocolo está diseñado para reducir la inflamación pélvica y sistémica en general, beneficiando también a mujeres con SOP, miomas o dolor menstrual severo.'
  }, {
    q: '¿Necesito comprar suplementos caros?',
    a: 'No. El protocolo se basa en alimentos reales y accesibles. Los suplementos son opcionales y solo se sugieren como apoyo, nunca como requisito.'
  }];
  return <section className="py-12 md:py-24 bg-forest" data-id="element-331">
      <FadeIn className="container mx-auto px-5 max-w-[860px]" data-id="element-332">
        <div className="text-center mb-10 md:mb-14" data-id="element-333">
          <span className="text-peach text-xs font-bold tracking-[0.2em] uppercase mb-4 block" data-id="element-334">
            Preguntas frecuentes
          </span>
          <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl text-cream leading-tight" data-id="element-335">
            Las dudas más comunes, respondidas
          </h2>
        </div>

        <div className="space-y-4" data-id="element-336">
          {faqs.map((faq, idx) => <AccordionItem key={idx} question={faq.q} answer={faq.a} data-id="element-337" />)}
        </div>
      </FadeIn>
    </section>;
}